import { useUserGroupRestriction } from '@/utils/hooks/acl/useUserGroupRestriction';
// Utils
import { useSearchBoxContext } from '@/utils/hooks/context/searchBox/useSearchBoxContext';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import Button from '@/components/base/Button';
// Components
import Icon from '@/components/base/Icon';
// Types
import type {
    ProfilesTabsProps,
    SocialProfileFormattedType
} from '@/components/layouts/LayoutPlatform/components/Header/components/ManageProfiles/Popover/ProfilesTab';
import { TooltipPlanRestriction } from '@/components/layouts/LayoutPlatform/components/Menu/components/TooltipPlanRestriction';

export function SaveAsGroupButton({ handleSaveSelectedProfiles }: ProfilesTabsProps) {
    const { t } = useTranslation('layout_platform');
    const { hasGroupPermission } = useUserGroupRestriction();

    const { dataContext } = useSearchBoxContext<SocialProfileFormattedType>();
    const { selectedItems } = dataContext;

    if (!selectedItems.length) {
        return <div className="h-2" />;
    }

    return (
        <div className="sticky bottom-0 z-10 flex justify-center bg-icoWhiteGradientBottomToTop py-3 dark:bg-icoDeepBlackGradientBottomToTop">
            <div className="rounded-m dark:bg-icoDarkMode-deepBlack">
                <TooltipPlanRestriction position="top" disabled={hasGroupPermission}>
                    <span>
                        <Button
                            size="sm"
                            onClick={() =>
                                handleSaveSelectedProfiles(selectedItems.map((item) => item.id))
                            }
                            disabled={!hasGroupPermission}
                            variant="secondary"
                            className="gap-1">
                            {t('manage_profiles.tab_profiles.save_as_group_button')}
                            {!hasGroupPermission ? <Icon icon="crown" /> : null}
                        </Button>
                    </span>
                </TooltipPlanRestriction>
            </div>
        </div>
    );
}
